import React from 'react';
import Toggle from './Toggle';

const RegionRestrictionEditor = ({ 
    restriction,
    restrictionName,
    enableRestriction,
    countryList,
    continentList,
    RegionRestrictionList,
}) => {

    const defaultRestriction = {
        enabled: false,
        countries: [],
        continents: [],
    };

    const restrictionWithDefaults = {
        ...defaultRestriction,
        ...restriction,
    };

    return (
        <div className="region-restriction-editor">
            <div className="form-group">
                <Toggle 
                    isOn={restrictionWithDefaults.enabled} 
                    onChange={({ isOn }) => enableRestriction({ restrictionName, enabled: isOn })} 
                />
                <label>Enable restriction</label>                
            </div>

            { 
                restrictionWithDefaults.enabled ? (
                    <React.Fragment>

                        <RegionRestrictionList 
                            title={ restrictionName === 'access' ? 'Countries' : 'Platform Instances' }
                            restrictionName={restrictionName}
                            restrictionRegionName="countries"
                            regions={restriction.countries}
                            regionList={countryList}
                            tableHeaderLabel="Country"
                        />

                        {
                            continentList 
                                ? (
                                    <RegionRestrictionList 
                                        title="Continents"
                                        restrictionName={restrictionName}
                                        restrictionRegionName="continents"
                                        regions={restriction.continents}
                                        regionList={continentList}
                                        tableHeaderLabel="Continent"
                                    />
                                )
                                : null
                        }
                        
                    </React.Fragment>
                ) : null
            }

        </div>
    );
};

export default RegionRestrictionEditor;
